<template>
  <div class="dob-group">
    <div class="dob-select">
      <select-wrapper
        :id="id"
        name="dob[d]"
        :options="days"
        v-model="parts.d"
      ></select-wrapper>
    </div>
    <div class="dob-select">
      <select-wrapper
        :id="`profile-dob-year_${this._uid}`"
        name="dob[m]"
        :options="months"
        v-model="parts.m"
      ></select-wrapper>
    </div>
    <div class="dob-select">
      <select-wrapper
        :id="`${id}-year`"
        name="dob[y]"
        :options="years"
        v-model="parts.y"
      ></select-wrapper>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
  },

  created() {
    if (this.value) {
      this.current = this.value;
    }
  },

  data() {
    return {
      current: null,
      parts: {
        d: null,
        m: null,
        y: null,
      },
    };
  },

  computed: {
    days() {
      // TODO switch to a datepicker if the client ever works out people can select 30feb, 31 apr, etc
      let options = [{ id: null, label: "Day" }];

      for (let x = 1; x <= 31; x++) {
        let label = (x < 10 ? "0" : "") + x;
        options.push({ id: label, label: label });
      }

      return options;
    },

    months() {
      let options = [{ id: null, label: "Month" }];

      for (let x = 1; x <= 12; x++) {
        let label = (x < 10 ? "0" : "") + x;
        options.push({ id: label, label: label });
      }

      return options;
    },

    years() {
      let options = [{ id: null, label: "Year" }];

      for (let x = 0; x < 100; x++) {
        let label = parseInt(dayjs().format("YYYY")) - x;
        options.push({ id: label, label: label });
      }

      return options;
    },
  },

  watch: {
    current(now) {
      // Because why use a datepicker when you can do this?
      if (now) {
        const parts = now.split(/\-/g);

        this.parts.y = parts[0];
        this.parts.m = parts[1];
        this.parts.d = parts[2];
      }

      this.$emit("input", this.current ? this.current : null);
    },

    value() {
      this.current = this.value;
    },

    parts: {
      handler() {
        if (this.parts.d && this.parts.m && this.parts.y) {
          this.current = this.parts.y + "-" + this.parts.m + "-" + this.parts.d;
        } else {
          this.current = null;
        }
      },
      deep: true,
    },
  },

  methods: {},
};
</script>
